/**
 * "Olvidé mi contraseña": las dos pantallas.
 *
 *   /recuperar              → pedir el enlace, escribiendo el email.
 *   /recuperar?id=…&c=…     → elegir la contraseña nueva.
 *
 * La regla que manda acá: ESTA PANTALLA NO DICE NUNCA si un email está
 * registrado. Contesta lo mismo en los dos casos. Si dijera algo distinto
 * —otro texto, otro color, o simplemente tardando más— se convertiría en una
 * forma de averiguar quién tiene cuenta en el sistema.
 */

const $ = (sel, dentro = document) => dentro.querySelector(sel);

function alerta(tipo, texto) {
  const simbolos = { critico: '!', aviso: '!', bien: '✓' };
  const div = document.createElement('div');
  div.className = `alerta ${tipo}`;
  div.setAttribute('role', tipo === 'critico' ? 'alert' : 'status');
  div.innerHTML = `<span class="simbolo" aria-hidden="true">${simbolos[tipo] ?? '·'}</span><span></span>`;
  div.lastElementChild.textContent = texto;
  return div;
}

/** ¿Esta carga de la página es una recuperación? */
export function esPantallaDeRecuperacion() {
  return location.pathname === '/recuperar' || location.pathname === '/recuperar/';
}

export function pantallaDeRecuperacion(contenedor, { pedir }) {
  const parametros = new URLSearchParams(location.search);
  const id = parametros.get('id');
  const secreto = parametros.get('c');
  // Con id y secreto viene de un enlace: se elige la contraseña.
  // Sin ellos, hay que pedir el enlace.
  if (id && secreto) elegirClave(contenedor, { pedir, id, secreto });
  else pedirEnlace(contenedor, { pedir });
}

// =======================================================================
// 1. Pedir el enlace
// =======================================================================
function pedirEnlace(contenedor, { pedir }) {
  contenedor.innerHTML = `
    <div class="tarjeta">
      <h1 style="font-size:20px;margin:0 0 6px">Recuperar el acceso</h1>
      <p style="color:var(--texto-suave);font-size:13.5px;margin:0 0 16px">
        Escribí el correo con el que entrás. Te llega un enlace para elegir una contraseña nueva.
      </p>
      <div data-rol="aviso"></div>
      <form id="formulario-recuperar" method="post" action="/api/recuperar" novalidate>
        <div class="campo">
          <label for="rec-email">Email</label>
          <input type="email" id="rec-email" name="email" autocomplete="username" required>
        </div>
        <button type="submit" class="boton principal" id="boton-pedir-enlace">
          Mandame el enlace</button>
      </form>
      <p style="margin:14px 0 0;text-align:center">
        <a href="/" style="font-size:13.5px">Volver al ingreso</a>
      </p>
    </div>`;

  const form = $('#formulario-recuperar', contenedor);
  const aviso = $('[data-rol="aviso"]', contenedor);
  const boton = $('#boton-pedir-enlace', contenedor);

  form.addEventListener('submit', async (evento) => {
    evento.preventDefault();
    aviso.innerHTML = '';
    boton.disabled = true;
    boton.textContent = 'Mandando…';

    const r = await pedir('/api/recuperar', { method: 'POST',
      body: JSON.stringify({ email: $('#rec-email', form).value.trim() }) });

    // La misma respuesta SIEMPRE. Ni siquiera se mira si salió bien: el
    // servidor contesta lo mismo exista o no ese email, y acá tampoco se
    // puede distinguir.
    form.hidden = true;
    aviso.appendChild(alerta('bien', r.cuerpo?.mensaje
      ?? 'Si ese correo tiene una cuenta, le llega un enlace. Vence a los 30 minutos.'));
  });
}

// =======================================================================
// 2. Elegir la contraseña nueva
// =======================================================================
function elegirClave(contenedor, { pedir, id, secreto }) {
  contenedor.innerHTML = `
    <div class="tarjeta">
      <h1 style="font-size:20px;margin:0 0 6px">Elegí tu contraseña nueva</h1>
      <p style="color:var(--texto-suave);font-size:13.5px;margin:0 0 16px">
        Al guardarla se cierran todas las sesiones que estén abiertas con tu usuario.
      </p>
      <div data-rol="aviso"></div>
      <form id="formulario-clave-nueva" method="post" action="/api/recuperar/confirmar" novalidate>
        <div class="campo">
          <label for="rec-clave">Contraseña nueva</label>
          <input type="password" id="rec-clave" name="clave" autocomplete="new-password" required>
          <div class="ayuda">Al menos 10 caracteres.</div>
        </div>
        <div class="campo">
          <label for="rec-clave2">Repetila</label>
          <input type="password" id="rec-clave2" name="claveRepetida"
                 autocomplete="new-password" required>
        </div>
        <button type="submit" class="boton principal" id="boton-guardar-clave">Guardar</button>
      </form>
      <p style="margin:14px 0 0;text-align:center">
        <a href="/" style="font-size:13.5px">Volver al ingreso</a>
      </p>
    </div>`;

  const form = $('#formulario-clave-nueva', contenedor);
  const aviso = $('[data-rol="aviso"]', contenedor);

  form.addEventListener('submit', async (evento) => {
    evento.preventDefault();
    aviso.innerHTML = '';
    const r = await pedir('/api/recuperar/confirmar', { method: 'POST',
      body: JSON.stringify({
        id, c: secreto,
        clave: $('#rec-clave', form).value,
        claveRepetida: $('#rec-clave2', form).value,
      }) });

    if (!r.ok) {
      for (const e of r.cuerpo?.errores
           ?? [{ rotulo: '', problema: r.cuerpo?.error ?? 'No se pudo guardar.' }]) {
        aviso.appendChild(alerta('critico', e.rotulo ? `${e.rotulo}: ${e.problema}` : e.problema));
      }
      return;
    }

    form.hidden = true;
    aviso.appendChild(alerta('bien', r.cuerpo.mensaje));
    // Se saca el secreto de la barra de direcciones: ya no sirve, pero no
    // tiene por qué quedar en el historial del navegador.
    history.replaceState(null, '', '/');
    setTimeout(() => { location.replace('/'); }, 4000);
  });
}
